import { UserInfoPageContent } from "../../components/organisms/UserInfoPageContent";
import { useRecoilState } from "recoil";
import { userState } from "../../states/user";
import { MoreTemplates } from "../../components/template/MoreTemplates";
import { useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { request } from "../../lib/api";
import { POST_USER_PROFILE_IMAGE } from "../../common/query-keys";
import imageCompression from "browser-image-compression";
import { useNavigate } from "react-router";

const UserInfoPage = () => {
  const [userData, setUserData] = useRecoilState(userState);
  const navigate = useNavigate();
  const inputRef = useRef<any>();

  /** 사용자 정보 수정 페이지 이동 함수 */
  const onEditPagesMoveHanlder = () => {
    navigate("/myinfo/myinfo-edit");
  };

  /** 이미지 선택 함수 */
  const onImgSelect = () => {
    inputRef.current.click();
  };

  /** 사용자 이미지 변경 함수 */
  const onChangeImg = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (!e.target.files) return;

    try {
      const imgFile = e.target.files[0];
      const formData = new FormData();

      // 이미지 압축 옵션
      const options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      const fileExtension = imgFile.name.split(".").pop();
      const compressedFile = await imageCompression(imgFile, options);

      // 압축된 파일에 확장자 추가
      const compressedFileWithExt = new File(
        [compressedFile],
        `${compressedFile.name}.${fileExtension}`,
        { type: compressedFile.type }
      );

      formData.append("image", compressedFileWithExt);

      const result: any = await ImgUploads(formData);

      setUserData((prev: any) => ({
        ...prev,
        profileImg: {
          ...prev.profileImg,
          imagename: result.imagename,
          imageUrl: result.imageUrl,
          size: result.size,
          id: result.id,
          createdAt: result.createdAt,
        },
      }));
    } catch (error) {
      console.log("ERRORS!: ", error);
    }
  };

  /** 이미지 업로드 함수 */
  const { mutateAsync: ImgUploads } = useMutation({
    mutationFn: (formData: FormData) => {
      return request({
        method: "POST",
        url: POST_USER_PROFILE_IMAGE,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onError: () => {
      alert("이미지 업로드 실패");
    },
  });

  return (
    <MoreTemplates
      pageHeaderTitle="설정"
      pageTitle="내 정보"
      background="white"
    >
      <UserInfoPageContent
        data={userData}
        inputRef={inputRef}
        onEditPagesMoveHanlder={onEditPagesMoveHanlder}
        onImgSelect={onImgSelect}
        onChangeImg={onChangeImg}
      />
    </MoreTemplates>
  );
};

export default UserInfoPage;
